module.exports = __webpack_public_path__ + "static/media/ciudadania-ETICA(B).246c4a10.svg";